import { SplitFactory } from '@splitsoftware/splitio';
import {
  IClient,
  INodeSettings,
} from '@splitsoftware/splitio/types/splitio';
import env from 'src/env';

type Config = INodeSettings & {
  core: {
    key: string;
    trafficType: string;
  };
};

interface Status {
  isInitializing: boolean;
  isReady: boolean;
}

let client: IClient;
const status: Status = {
  isInitializing: false,
  isReady: false,
};

let baseAttributes: any;

const config: Config = {
  core: {
    authorizationKey: env.SPLIT_IO_AUTH_KEY,
    /*
     * The key can be the logged-in user id, or the account id that
     * the logged in user belongs to.
     * The type of customer (user, account, custom)
     * is chosen during Split's sign-up process.
     */
    key: 'anonymous', // this gets set in the init function
    trafficType: 'User',
  },
  startup: {
    // Maximum amount of time in seconds to wait before firing the SDK_READY_TIMED_OUT event.
    readyTimeout: 5.0,
  },
  /*
   * Enables logging in the browser.
   * You can also open the DevTools console and type: localstorage.splitio_debug = 'on'
   */
  debug: false,
};

/**
 * Initializes the split.io client
 * @param userKey {string} The user's email, the Segment anonymous id, or 'anonymous'
 */
export const init = (userKey: string, commonMetricData: any) => {
  config.core.key = userKey;
  baseAttributes = commonMetricData;

  const factory: SplitIO.ISDK = SplitFactory(config);
  status.isInitializing = true;

  client = factory.client();

  client.on(client.Event.SDK_READY, () => {
    status.isInitializing = false;
    status.isReady = true;
  });
};

export const getConfig = () => config;
export const getClient = (): IClient => client;
export const getStatus = (): Status => status;
export const getBaseAttributes = (): any => baseAttributes;

export const getSplitIOTreatment = (flagName: string) => {
  const attributes = { ...baseAttributes };
  return client?.getTreatment(flagName, attributes);
};

export const getSplitIOTreatmentWithConfig = (flagName: string) => {
  const attributes = { ...baseAttributes };
  const treatment = client?.getTreatmentWithConfig(flagName, attributes);
  return {
    ...treatment,
    config: treatment?.config ? JSON.parse(treatment.config) : {},
  };
};

export default {
  init,
  getConfig,
  getClient,
  getStatus,
  getSplitIOTreatment,
  getSplitIOTreatmentWithConfig,
  getBaseAttributes,
};
